import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';

import { enTranslation } from './en/translation';
import { ruTranslation } from './ru/translation';
import { EFB_DEFAULT_LANGUAGE, EFB_LOCAL_STORAGE_NAME } from './constants';

const langFromStorage = localStorage.getItem(EFB_LOCAL_STORAGE_NAME);
const defaultLanguage = langFromStorage ? JSON.parse(langFromStorage) : EFB_DEFAULT_LANGUAGE;

const i18nOptions = {
    debug: process.env.NODE_ENV !== 'production',
    defaultNS: 'translations',
    keySeparator: false,
    lng: defaultLanguage,
    interpolation: {
        escapeValue: false,
    },
    fallbackLng: defaultLanguage,
    ns: ['translations'],
    resources: {
        en: {
            translations: enTranslation,
        },
        ru: {
            translations: ruTranslation,
        },
    },
    returnNull: false,
};

i18n.use(initReactI18next).init(i18nOptions);

export default i18n;
